module.exports = __webpack_public_path__ + "img/interfaces.b09aa292.svg";